import _ from 'lodash'

export default {
    methods: {
        hasCode(val) {
            return this.notEmpty(val);
        },
        notEmpty(val) {
            return val !== undefined && val != null && val !== '';
        },
        emptyToDefault(val, def) {
            return this.hasCode(val) ? val : def;
        },
        postExport({url, data, name}) {
            this.$store.dispatch("api/post", {
                url: process.env.VUE_APP_REPORT_API_URL + "report-service/mmf/report/dispatcher/asynchronous",
                data: {
                    requestUrl: url,
                    requestParam: data,
                    reportName: name
                }
            }, {
                root: true
            }).then(() => this.$message.success("操作成功"));
        },
        pushAll(source, target) {
            for (let item of source) {
                target.push(item);
            }
        },
        copyObj2Obj(source, target, force = false) {
            let temp = this.deepCopyObj(source);
            for (let key in temp) {
                if (force || !target[key]) {
                    target[key] = temp[key];
                }
            }
        },
        deepCopyObj(source) {
            return _.cloneDeep(source);
        },
        genNonDuplicateID(randomLength) {
            return Number(Math.random().toString().substring(3, randomLength + 3) + Date.now()).toString(36)
        },
        downloadWithHeader(url, fileName, requestFinish = () => {
        }, method = 'GET', body = null) {
            let failed = false;
            let config = {
                method: method,
                headers: new Headers({
                    Authorization: localStorage['em_sso_token'],
                    "Content-Type": "application/json",
                }),
            }
            if (method === 'POST') {
                config.body = JSON.stringify(body);
            }
            fetch(url, config)
                .then(res => {
                    if (res.ok) {
                        return res.blob();
                    } else {
                        failed = true;
                        requestFinish(false);
                        return null;
                    }
                })
                .then(data => {
                    if (data != null) {
                        let blobUrl = window.URL.createObjectURL(data);
                        let downEle = document.createElement('a');
                        downEle.href = blobUrl;
                        downEle.setAttribute('download', fileName);
                        document.body.appendChild(downEle);
                        downEle.click();
                        downEle.remove();
                    }
                })
                .finally(() => {
                    if (!failed) {
                        requestFinish(true);
                    }
                });
        },

        getSearchReg(str) {
            return new RegExp(".*" + str + ".*", "i");
        },

        getRefEl(ref) {
            let temp = this.$refs[ref];
            if (temp && temp instanceof Array && temp[0]) {
                return temp[0];
            } else {
                return temp;
            }
        },

        _toMapList(list, key) {
            let map = new Map();
            if (list) {
                list.forEach(item => {
                    let k = item[key];
                    if (k) {
                        if (map.has(k)) {
                            map.get(k).push(item);
                        } else {
                            map.set(k, [item]);
                        }
                    }
                });
            }
            return map;
        },

        getUrlTokenStr(firstParam = false) {
            return (firstParam ? '?' : '&') + "token=" + localStorage['em_sso_token'];
        },

        _mapToObject(map) {
            return [...map.entries()].reduce((obj, [key, value]) => (obj[key] = value, obj), {});
        },

        _strLengthZh2(str) {
            if (!this.hasCode(str)) {
                return 0;
            }
            let len = 0;
            for (let i = 0; i < str.length; i++) {
                if ((str.charCodeAt(i) & 0xff00) !== 0) {
                    len++;
                }
                len++;
            }
            return len;
        },
        _baseUrl(entity) {
            return `${this.$store.state[entity].baseModuleUrl}/${entity}/`;
        },
        _arrayValueCount(list, key, addPredicate = item => true) {
            let temp = {};
            for (let item of list) {
                let k = item[key];
                if (k && addPredicate(item)) {
                    if (temp[k]) {
                        temp[k]++;
                    } else {
                        temp[k] = 1;
                    }
                }
            }
            return temp;
        },
        _camelToTitleCase(str) {
            return str.replace(/([A-Z])/g, ' $1') // 将大写字母前添加空格
                .replace(/^./, str => str.toUpperCase()) // 将首字母大写
                .trim();
        },
        _translateDict(code, value) {
            return this.$store.getters['dictionaryEnumStore/translate'](code, value);
        },
        _generateDownloadUrl(val) {
            return process.env.VUE_APP_EM_ADMIN_URL + "/emAttachment/download?attachmentId=" + val;
        },
        _getQueryParam(url, param) {
            const regex = new RegExp('[?&]' + param + '(=([^&#]*)|&|#|$)');
            const results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }
    }
}
